import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useEffect } from "react";
import React from "react";

const BaseProgressBar = ({ steps }) => {
  const [currentStep, setCurrentStep] = useState(steps[0]);
  const [totalSteps, setTotalSteps] = useState(10);

  useEffect(() => {
    setCurrentStep(steps[0]);
    setTotalSteps(steps.length);
  }, [steps]);

  const getProgressBarClass = (step, index, totalSteps) => {
    const isFirstStep = index === 0;
    const isLastStep = index === totalSteps - 1;
    const isDone =
      parseInt(currentStep?.sort_order) >= parseInt(step?.sort_order);

    if (isFirstStep) return "First-LI Step-List-Item";
    if (isLastStep && isDone) return "Done Last-LI Step-List-Item";
    if (isLastStep && !isDone) return "To-Do Last-LI Step-List-Item";
    if (isDone) return "Done Block Step-List-Item";
    return "To-Do Block Step-List-Item";
  };

  const nextStep = () => {
    if (currentStep.sort_order < totalSteps) {
      let newStep = parseInt(currentStep.sort_order) + 1;
      setCurrentStep(steps[newStep - 1]);
    }
  };

  const prevStep = () => {
    if (currentStep.sort_order > 1) {
      let newStep = parseInt(currentStep.sort_order) - 1;
      setCurrentStep(steps[newStep - 1]);
    }
  };

  return (
    <div className="pt-1 marg-5 max-h-25 Column">
      <div className="Justify-Center ">
        {totalSteps < 11 ? (
          <div className="Row marg-t-1 max-h-1 max-w-15">
            {steps.map((step) => {
              return (
                <div key={step.id}>
                  <ul className="p0 Row">
                    <li
                      onClick={() => {
                        setCurrentStep(step);
                      }}
                      className={
                        parseInt(currentStep?.sort_order) >=
                        parseInt(step?.sort_order)
                          ? "Done Step-List-Item"
                          : "To-Do Step-List-Item"
                      }
                    >
                      {step?.sort_order}
                    </li>
                  </ul>
                  {step?.sort_order < totalSteps && (
                    <hr
                      className={
                        step?.sort_order > currentStep?.sort_order - 1
                          ? "Progress-Bar-To-Do"
                          : "Progress-Bar-Done"
                      }
                    />
                  )}
                </div>
              );
            })}
          </div>
        ) : (
          <div className="marg-t-1 w-90">
            <ul className="Progress-Bar-UL w-100">
              {steps.map((step, index) => {
                return (
                  <li
                    key={step.id}
                    onClick={() => {
                      setCurrentStep(step);
                    }}
                    className={getProgressBarClass(step, index, totalSteps)}
                    style={{
                      width: 100 / totalSteps + "%",
                    }}
                  />
                );
              })}
            </ul>
          </div>
        )}
      </div>

      <div className="Step-Card-Container Justify-Center">
        {currentStep && (
          <div className="Justify-Center">
            <div className="Row Width-25">
              <button className="Arrow-Left-Btn" onClick={prevStep}>
                <FontAwesomeIcon className="Arrow-Left" icon={faArrowDown} />
              </button>
              <section className="Step-Card">
                <h3 className="Justify-Center marg-1">
                  Step {currentStep?.sort_order}
                </h3>
                <div className="Step-Detail p1">
                  <p>{currentStep.detail}</p>
                </div>
              </section>
              <button className="Arrow-Right-Btn" onClick={nextStep}>
                <FontAwesomeIcon className="Arrow-Right" icon={faArrowDown} />
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BaseProgressBar;
